import { Component, Mixins } from 'vue-property-decorator';
import commonEntry from '@/store/modules/commonEntry';
import UIkit from 'uikit';
import AccountSettings from '@/mixins/accountSettings.mixin';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';

@Component({})
export default class ChangeEmail extends Mixins(AccountSettings, DeviceWidthCheckerMixin) {
  public newEmail: string = '';
  public currentPassword: string = '';
  public closeChangeEmail: boolean = false;
  public showConfirmation: boolean = false;

  public async onSubmit(): Promise<void> {
    const changeEmailObj = {
      newEmail: this.newEmail,
      password: this.currentPassword
    };
    const response = await commonEntry.changeEmail(changeEmailObj);
    if (response.status === 200) {
      this.closePopup();
    }
  }

  public closePopup() {
    this.newEmail = '';
    this.currentPassword = '';
    this.closeChangeEmail = !this.closeChangeEmail;
    this.showConfirmation = false;
    commonEntry.submitMutate({});
    if (UIkit) {
      UIkit.modal('#email-screen').hide();
    }
  }
}